var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFree(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 170,
    height: 170,
    viewBox: "0 0 170 170",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#2d3c6b;}.b{fill:#c3e678;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.119 0.119)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M0,85a85,85,0,1,1,85,85A85,85,0,0,1,0,85Z",
    transform: "translate(-0.119 -0.119)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M0,61.028A65.01,65.01,0,0,1,42.606,0V27.728a40.118,40.118,0,1,0,44.76,0V0A64.993,64.993,0,1,1,0,61.028Z",
    transform: "translate(19.896 23.853)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M12.436,64.989H0V1.168L1.669.889A65.608,65.608,0,0,1,23.2.889l1.669.278V64.989Z",
    transform: "translate(72.446 19.9)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFree);
export default __webpack_public_path__ + "static/media/free.4235610f979e1e43e8433e857b5c1592.svg";
export { ForwardRef as ReactComponent };